<mat-card>
    <mat-card-header>
        <mat-card-title id="inforReport" class="mat-card-title-custom">{{'contract_user_create.card_tile' | translate}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
        <!-- Filter -->
        <mat-accordion #accordion="matAccordion" [multi]="true" >
            <mat-expansion-panel [(expanded)]="isExpanded" class="mt-3">
                <mat-expansion-panel-header >
                    <mat-panel-title class="mat-panel-title" *ngIf="createdTime">
                        {{'report_components.filter_title' | translate}} (ngày {{ createdTime | date:'dd/MM/yyyy HH:mm:ss'}})
                    </mat-panel-title>
                  <mat-panel-title class="mat-panel-title" *ngIf="!createdTime">
                    {{'report_components.filter_title' | translate}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <form #myForm="ngForm" class="pb-3" >
                    <div class="row">
                        <!-- Phòng ban/Chi nhánh -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.department' | translate}}</mat-label>

                                <mat-select
                                    #branchesSelect
                                    (focusout)="(checkFocus = true)"
                                    (selectionChange)="onDepartmentChange()"
                                    (focus)="commonService.openComboBox(checkFocus, branchesSelect)"
                                    id="departmentIds"
                                    name="departmentIds"
                                    [(ngModel)]="documents.departmentIds"
                                    [multiple]="true">

                                    <mat-option>
                                        <ngx-mat-select-search
                                            [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                            [placeholderLabel]="'search_form.search' | translate"
                                            [formControl]="branchesFilterCtrl">
                                        </ngx-mat-select-search>
                                    </mat-option>

                                    <mat-option
                                        #allSelectedBranch
                                        (click)="clickOptionBranchesAll()">
                                        {{ 'form.choose_all' | translate }}
                                    </mat-option>

                                    <mat-option
                                        *ngFor="let branch of filteredBranches | async"
                                        [value]="branch.idString"
                                        (click)="clickOptionBranches(branch)">
                                        {{ branch.name }}
                                    </mat-option>

                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Người lập -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <mat-label >{{'search_form.created_by' | translate}}</mat-label>
                                <mat-select #createdUserSelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, createdUserSelect)" id="createdUser"
                                    name="createdUser" [(ngModel)]="documents.createdUserId" [multiple]="true">
                                    <mat-option>
                                        <ngx-mat-select-search
                                            [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                            [placeholderLabel]="'search_form.search' | translate"
                                            [formControl]="createdUserFilterCtrl">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option #allSelectedUserCreated (click)="clickOptionCreatedUserAll()">
                                        {{ 'form.choose_all' | translate }}
                                    </mat-option>
                                    <mat-option *ngFor="let createdUser of filteredCreatedUser | async"
                                        [value]="createdUser.id" (click)="clickOptionCreatedUser(createdUser)">
                                        {{createdUser.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian lập (từ ngày) -->
                        <div class="col-lg-4 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.created_date_from' | translate }}</mat-label>
                                <input matInput [matDatepicker]="createdFromDateRef" [max]="documents.createdToDate"
                                    #createdFromDateCtrl="ngModel"
                                    (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['createdFromDate'])"
                                    name="createdFromDate" #pickerInput [(ngModel)]="documents.createdFromDate"
                                    maxlength="200" (focus)="createdDateErr = 'createdFromDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="createdFromDateRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #createdFromDateRef></mat-datepicker>
                                <mat-error *ngIf="createdFromDateCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>
                                <mat-error
                                    *ngIf="createdFromDateCtrl?.errors?.matDatepickerMax && createdDateErr == 'createdFromDate'">
                                    {{ 'search_form.created_date_from' | translate }}
                                    {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                                    {{ 'search_form.created_date_to' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Thời gian lập (đến ngày) -->
                        <div class="col-lg-4 col-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{ 'search_form.created_date_to' | translate }}</mat-label>
                                <input matInput [matDatepicker]="createdToDateRef" [min]="documents.createdFromDate"
                                    (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['createdToDate'])"
                                    name="createdToDate" #pickerInput1 [(ngModel)]="documents.createdToDate"
                                    #createdToDateCtrl="ngModel" maxlength="200"
                                    (focus)="createdDateErr = 'createdToDate'" autocomplete="off" />
                                <mat-datepicker-toggle matSuffix [for]="createdToDateRef">
                                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                                        [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                                </mat-datepicker-toggle>
                                <mat-datepicker #createdToDateRef></mat-datepicker>
                                <mat-error *ngIf="createdToDateCtrl?.errors?.matDatepickerParse">
                                    {{'validation.format_of_date' | translate}}
                                </mat-error>
                                <mat-error
                                    *ngIf="createdToDateCtrl?.errors?.matDatepickerMin && createdDateErr == 'createdToDate'">
                                    {{ 'search_form.created_date_to' | translate }}
                                    {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                                    {{ 'search_form.created_date_from' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Loại dịch vụ -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{'form.service_type' | translate}}</mat-label>
                                <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)" id="serviceType"
                                    name="serviceType" [(ngModel)]="documents.serviceTypeId" [multiple]="true">
                                    <mat-option>
                                        <ngx-mat-select-search
                                            [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                            [placeholderLabel]="'search_form.search' | translate"
                                            [formControl]="serviceTypesFilterCtrl">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option #allSelectedServiceType (click)="clickOptionServiceTypeAll()">
                                        {{ 'form.choose_all' | translate }}
                                    </mat-option>
                                    <mat-option *ngFor="let serviceType of filteredServiceTypes | async"
                                        [value]="serviceType.id" (click)="clickOptionServiceType()">
                                        {{serviceType.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Mẫu hợp đồng -->
                        <div class="col-lg-4 col-md-6">
                            <mat-form-field class="w-100">
                                <mat-label>{{'search_form.contract_template' | translate}}</mat-label>
                                <mat-select #templateSelect (focusout)="(checkFocus = true)"
                                    (selectionChange)="checkFocus = false"
                                    (focus)="commonService.openComboBox(checkFocus, templateSelect)" id="templateIds"
                                    name="templateIds" [(ngModel)]="documents.templateIds" [multiple]="true">
                                    <mat-option>
                                        <ngx-mat-select-search
                                            [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                            [placeholderLabel]="'search_form.search' | translate"
                                            [formControl]="templateFilterCtrl">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option #allSelectedTemplate (click)="clickOptionTemplateAll()">
                                        {{ 'form.choose_all' | translate }}
                                    </mat-option>
                                    <mat-option *ngFor="let template of filteredTemplates | async"
                                        [value]="template.id" (click)="clickOptionTemplate()">
                                        {{ template.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-card-content>
    <div class="row mt-3" style="margin-bottom: 15px;">
        <div class="col-lg-12 d-flex justify-content-center">
            <button mat-raised-button color="primary" type="submit" (click)="onExportReport()"
                [disabled]="!myForm.valid">
                <mat-icon class="mr-0" style="font-weight: 900;">receipt_long</mat-icon>
                {{'total_contract_report.title_btn' | translate}}
            </button>
        </div>
    </div>
</mat-card>
<app-history-report [mode]="mode" [formExport]="exportForm" (filterForm)="filterForm($event)"></app-history-report>
<ng4-loading-spinner *ngIf="showSpinner" [threshold]="1000" [timeout]="100000" [zIndex]="9999"></ng4-loading-spinner>